<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'

import GenericHistorical from '@/views/historical/GenericHistorical.vue'

import { getSociedad } from '@/services/configurations/getSociedad'
import { getHistoricalByContact } from '@/services/historical/getHistoricalByContact'
import { getHistoricalByContactExcel } from '@/services/historical/getHistoricalByContactExcel'

export default {
  name: 'list-trash-contact-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 60,
      vuexnamespace: 'trashHistoricalContacts',
      headerUrl: 'trash/society/details',
      breadcrumbs: [
        { url: 'trash/society', name: i18n.t('trash.header') },
        { url: 'trash/society', name: i18n.t('agenda.deleted_sociedades') },
        { paths: ['Name', 'FirstSurname'] },
      ],
      ExcelName: `${_.kebabCase(i18n.t('agenda.sociedad') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  computed: {
    isRoleProvider: function () {
      return this.role === 9
    },
  },
  methods: {
    getParamsAux: function (data) {
      return { idSociedad: parseInt(this.$route.params.id) }
    },
    getParamsDetalleAux: function (data) {
      return { ...this.getParamsAux(data), borrado: true }
    },
    getDetalleAux: async function (params) {
      return await getSociedad(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByContactExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByContact(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
